import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  signInWithEmailAndPassword,
  signInWithRedirect,
  getRedirectResult,
  GoogleAuthProvider,
} from "firebase/auth";
import {
  getDoc,
  setDoc,
  doc,
  getFirestore
} from "firebase/firestore";

import { auth, googleProvider } from "../../firebase";
import { setPersistence, browserLocalPersistence } from "firebase/auth";
import { signInWithPopup } from "firebase/auth";

function Login({ toggleForm }) {
  const navigate = useNavigate();
  const firestore = getFirestore();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [alert, setAlert] = useState("");

  useEffect(() => {
  setPersistence(auth, browserLocalPersistence)
    .then(() => {
      console.log("Persistence set to local");
    })
    .catch((error) => {
      console.error("Error setting persistence:", error);
    });
}, []);

  // ✅ Handle Google Redirect Result on Component Mount
  // useEffect(() => {
  //   getRedirectResult(auth)
  //     .then(async (result) => {
  //       const user = result?.user;
  //       if (user) {
  //         const docRef = doc(firestore, "users", user.uid);
  //         const docSnap = await getDoc(docRef);

  //         if (!docSnap.exists()) {
  //           await setDoc(docRef, {
  //             uid: user.uid,
  //             email: user.email,
  //             role: "agent",
  //             profileComplete: false,
  //             name: user.displayName || "",
  //             isActive: true,
  //             credits: 0,
  //             downloads: [],
  //           });
  //           console.log("New Google user registered in Firestore:", user.email);
  //         }

  //         setAlert("Google login successful!");
  //         navigate("/dashboard");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Redirect login error:", error);
  //       setAlert(error.message);
  //     });
  // }, []);

  useEffect(() => {
  const unsubscribe = auth.onAuthStateChanged(async (user) => {
    if (user) {
      // Already logged in
      navigate("/seva-dashboard");
    } else {
      // Not logged in, try to fetch redirect result
      try {
        const result = await getRedirectResult(auth);
        if (result?.user) {
          const user = result.user;
          const docRef = doc(getFirestore(), "users", user.uid);
          const docSnap = await getDoc(docRef);

          if (!docSnap.exists()) {
            await setDoc(docRef, {
              uid: user.uid,
              email: user.email,
              profileComplete: false,
              role: "agent",
              name: user.displayName || "",
              isActive: true,
              credits: 0,
              downloads: [],
            });
          }

          navigate("/dashboard");
        }
      } catch (error) {
        console.error("Redirect login error:", error);
        setAlert(error.message);
      }
    }
  });

  return () => unsubscribe();
}, []);


  // ✅ Email/Password Login
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const uid = userCredential.user.uid;

      const docRef = doc(firestore, "users", uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setAlert("Login successful!");
        navigate("/dashboard");
      } else {
        setAlert("User not found in database. Please register.");
        if (toggleForm) toggleForm();
      }
    } catch (error) {
      console.error("Login error:", error);
      setAlert(error.message);
    }
  };

  // ✅ Redirect to Register Page
  const register = () => {
    navigate("/register");
  };

  // ✅ Google Login with Redirect
 const handleGoogleLogin = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    const user = result.user;

    const docRef = doc(getFirestore(), "users", user.uid);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      await setDoc(docRef, {
        uid: user.uid,
        email: user.email,
        name: user.displayName || "",
        profileComplete: false,
        isActive: true,
        role: "agent",
        credits: 0,
        downloads: [],
      });
    }

    setAlert("Google login successful!");
    navigate("/dashboard");
  } catch (error) {
    console.error("Popup login error:", error);
    setAlert(error.message);
  }
};
  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
      <div className="card p-4" style={{ maxWidth: "400px", width: "100%" }}>
        <h4 className="text-center">Login</h4>
        {alert && <div className="alert alert-info">{alert}</div>}
        <form onSubmit={handleLogin}>
          <input
            type="email"
            className="form-control mb-2"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            className="form-control mb-2"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button className="btn btn-primary w-100">Login</button>
        </form>
        <hr />
        <button
          className="btn btn-danger w-100 mb-2"
          onClick={handleGoogleLogin}
        >
          Login with Google
        </button>
        <p className="text-center">
          Don't have an account?{" "}
          <button className="btn btn-link" onClick={register}>
            Register
          </button>
        </p>
      </div>
    </div>
  );
}

export default Login;
